'use strict';

var ConfigurationFlightAssignmentDirective = function ConfigurationFlightAssignmentDirective() {
  return {
    restrict: 'E',
    controller: 'ConfigurationFlightAssignmentController',
    template: require('../templates/configuration-flight-assignment.html'),
    link: function link(scope) {
      scope.$on('configuration-assignment-grid:saveChanges', scope.saveChanges);
      scope.$on('configuration-assignment-grid:remove', scope.removeFlightAssignements);
    }
  };
};
ConfigurationFlightAssignmentDirective.$inject = [];
module.exports = ConfigurationFlightAssignmentDirective;